import Vue from 'vue';

export default function useBs4TooltipDirective() {
    Vue.directive('bs4-tooltip', function (el, binding) {
        $(el).tooltip({
            title: binding.value,
            placement: binding.arg,
            trigger: 'hover focus'
        });
    });
}